import { createBrowserRouter, Navigate } from "react-router-dom";

// import RoutingAPI from "../pages/routing-api";
// import RoutePlannerAPI from "../pages/route-planner-api";
// import RouteMatrixAPI from "../pages/route-matrix-api";
import MapMatchingAPI from "../pages/map-matching-api";
import SearchAPI from "../pages/search-api";
import ReverseGeocodingAPI from "../pages/reverse-geocoding-api";
import AutocompleteAPI from "../pages/autocomplete-api";
import PlaceAPI from "../pages/place-api";
import AddressParsingAPI from "../pages/address-parsing-api";
import NotFoundPage from "../pages/not-found";
import HomePage from "../pages/home";
import ContactUs from "../pages/contact-us";
import AddressValidationAPI from "../pages/address-validation-api";
import RoutePlannerAPIV3 from "../pages/route-planner-api-v3";
import BuildingsAPI from "../pages/buildings-api";
import RoutingAPIV3 from "../pages/routing-api-v3";
import LocationImageAPI from "../pages/location-image-api";
import RouteMatrixAPIV3 from "../pages/route-matrix-api-v3";
import RoutePlannerAPIV4 from "../pages/route-planner-api-v4";
import RoutingAPIV4 from "../pages/routing-api-v4";
import RouteMatrixAPIV4 from "../pages/route-matrix-api-v4";
import Routing2APIV4 from "../pages/routing-2-api-v4";
import RouteMatrix2APIV4 from "../pages/route-matrix-2-api-v4";


const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  // {
  //   path: "routing-api",
  //   element: <RoutingAPI />,
  // },
  // {
  //   path: "route-planner-api",
  //   element: <RoutePlannerAPI />,
  // },
  // {
  //   path: "route-matrix-api",
  //   element: <RouteMatrixAPI />,
  // },
  {
    path: "map-matching-api",
    element: <MapMatchingAPI />,
  },
  {
    path: "search-api",
    element: <SearchAPI />,
  },
  {
    path: "reverse-api",
    element: <ReverseGeocodingAPI />,
  },
  {
    path: "autocomplete-api",
    element: <AutocompleteAPI />,
  },
  {
    path: "place-api",
    element: <PlaceAPI />,
  },
  {
    path: "address-parsing-api",
    element: <AddressParsingAPI />,
  },
  {
    path: "address-validation-api",
    element: <AddressValidationAPI />,
  },
  {
    path: "route-planner-api-v3",
    element: <RoutePlannerAPIV3/>,
  },
  {
    path: "route-planner-api-v4",
    element: <RoutePlannerAPIV4/>,
  },
  {
    path: "routing-api-v3",
    element: <RoutingAPIV3 />,
  },
  {
    path: "route-matrix-api-v3",
    element: <RouteMatrixAPIV3 />,
  },
  {
    path: "routing-api-v4",
    element: <RoutingAPIV4 />,
  },
  {
    path: "route-matrix-api-v4",
    element: <RouteMatrixAPIV4 />,
  },
  {
    path: "routing-2-api-v4",
    element: <Routing2APIV4 />,
  },
  {
    path: "route-matrix-2-api-v4",
    element: <RouteMatrix2APIV4 />,
  },
  {
    path: "buildings-api",
    element: <BuildingsAPI />,
  },
  {
    path: "location-image-api",
    element: <LocationImageAPI/>,
  },
  {
    path: "404",
    element: <NotFoundPage />,
  },
  {
    path: "*",
    element: <Navigate to="/404" replace={true} />,
  },
]);

export default router;
